module.exports = __webpack_public_path__ + "static/logo-c662be8c119ac2ec964fc5baa5fdd3e5.png";